<template>
    <div class="container">
        <main-header></main-header>
        <div class="mainContent">
            <router-view></router-view>
        </div>
        <main-footer></main-footer>
        <div class="slider">
          <ul>
            <li class="slider_image">
              <img src="../assets/images/publicAddress.png" alt=""><br>
              <span>官方微信</span>
            </li>
            <li class="slider_qq" >
              <span><a target="_blank" href="http://wpa.qq.com/msgrd?v=3&uin=253693571&site=qq&menu=yes"></a></span>
              <div><a target="_blank" href="http://wpa.qq.com/msgrd?v=3&uin=253693571&site=qq&menu=yes"><span>在线咨询</span></a></div>
            </li>
            <li class="slider_wechat">
              <span></span>
              <div>
                <span>扫一扫添加</span>
                <img src="../assets/images/wechat.png" alt="">
              </div>
            </li>
            <li class="slider_up">
              <span @click="pageToTop"></span>
              <div @click="pageToTop"><span>返回顶部</span></div>
            </li>
          </ul>
        </div>
    </div>
</template>

<script>
    import mainHeader from '../components/mainHeader'
    import mainFooter from '../components/mainFooter'
    import $ from 'jquery'
    export default {
        name: 'index',
        data:function(){
            return {

            }
        },
      watch:{
        $route(to,from){
          if(to.path == '/'){
            if(!$('.main_header>ul>li:nth-child(2)').hasClass('is-active')){
              $('.main_header>ul>li:nth-child(2)').addClass('is-active').siblings().removeClass('is-active');
            }
            $('.main_header>ul>li:nth-child(2)').siblings().removeClass('is-active');
          }
          var routeObj = [{path:'/index',index:2},{path:'/intelligent',index:3},{path:'/project',index:4},{path:'/live',index:5},{path:'/contact',index:6}];
          for(var i=0;i<routeObj.length;i++){
            var currentPath = routeObj[i].path;
            var currentIndex = routeObj[i].index;
            if(to.path == currentPath){
              if(!$('.main_header>ul>li:nth-child('+currentIndex+')').hasClass('is-active')){
                $('.main_header>ul>li:nth-child('+currentIndex+')').addClass('is-active').siblings().removeClass('is-active');
              }
              $('.main_header>ul>li:nth-child('+currentIndex+')').siblings().removeClass('is-active');
            }
          }
        }
      },
        mounted:function(){

        },
        methods:{
          pageToTop:function(){
            $('body,html').animate({scrollTop: 0}, 300);
          }
        },
        components:{mainHeader,mainFooter}
    }
</script>



// WEBPACK FOOTER //
// src/components/index.vue